import { type FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { App } from '@/components/App.tsx';
import { ErrorBoundary } from '@/components/ErrorBoundary.tsx';
import { AuthProvider } from '@/hooks/useAuth.tsx';
import Router from '@/navigation/Router.tsx';
import { WebSocketProvider } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';

const ErrorBoundaryError: FC<{ error: unknown }> = ({ error }) => (
  <div>
    <p>An unhandled error occurred:</p>
    <blockquote>
      <code>
        {error instanceof Error
          ? error.message
          : typeof error === 'string'
            ? error
            : JSON.stringify(error)}
      </code>
    </blockquote>
  </div>
);

const Inner: FC = () => (
  <BrowserRouter>
    <AuthProvider>
      <WebSocketProvider>
        <App>
          <Router />
        </App>
      </WebSocketProvider>
    </AuthProvider>
  </BrowserRouter>
);

export const Root: FC = () => (
  <ErrorBoundary fallback={ErrorBoundaryError}>
    <Inner />
  </ErrorBoundary>
);
